import React, {useState, useEffect} from 'react'
import {makeStyles} from '@material-ui/core/styles'
import {
    IconButton,
    TextField,
    Box,
    Button,
    Typography,
    ClickAwayListener,
    Paper,
} from '@material-ui/core'
import MenuItem from '@material-ui/core/MenuItem'
import Tooltip from '@material-ui/core/Tooltip'
import FilterListIcon from '@material-ui/icons/FilterList'
import {
    MobileDateRangePicker,
    DateRangeDelimiter,
    DesktopDateRangePicker,
    LocalizationProvider,
} from '@material-ui/pickers'
import enLocale from 'date-fns/locale/en-US'
import DateFnsAdapter from '@material-ui/pickers/adapter/date-fns'
import useMediaQuery from '../../../../components/useMediaQuery'

const useStyles = makeStyles(theme => ({
    filterlabel: {
        marginTop: '-5px',
    },
    paper: {
        position: 'absolute',
        zIndex: '100',
        top: 60,
        right: 5,
        borderRadius: '0px',
        padding: '10px',
        width: '360px',
        whiteSpace: 'normal',
        color: '#fff',
    },
    outlineButton: {
        boxShadow: 'none',
        width: '48%',
        '&:hover': {
            boxShadow: 'none',
            backgroundColor: '#00000029',
        },
        '&:focus': {
            boxShadow: 'none',
            backgroundColor: '#00000029',
        },
    },
    containedButton: {
        boxShadow: 'none',
        width: '48%',
        '&:hover': {
            boxShadow: 'none',
            opacity: 0.9,
        },
        '&:focus': {
            boxShadow: 'none',
            backgroundColor: theme.palette.green.dark,
        },
    },
    filterbuttonBox: {
        margin: '15px 0',
        fontSize: '0.825rem',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
}))

export default function OccurrenceTableFilter(props) {
    const isMobile = useMediaQuery('(max-width: 600px)')
    const {
        selectedDate,
        filterswiping,
        handleDateChange,
        setFilterSwiping,
    } = props
    const classes = useStyles()
    const [filteredDate, setDatefilter] = useState([null, null])
    const [filteredswiping, setSwipingfilter] = useState('Show All')

    const [open, setOpen] = useState(false)

    const handleClick = () => {
        setOpen(!open)
    }

    const handleClose = () => {
        setOpen(false)
    }

    const handleStatusChange = e => {
        e.stopPropagation()
        setSwipingfilter(e.target.value)
    }

    const handleDatefilterChange = e => {
        e.stopPropagation()
        setDatefilter(e.target.value)
    }

    const handleApply = () => {
        handleDateChange(filteredDate)
        setFilterSwiping(filteredswiping)
    }

    const handleClearAll = () => {
        setDatefilter([null, null])
        setSwipingfilter('Show All')
        handleDateChange([null, null])
        setFilterSwiping('Show All')
    }

    useEffect(() => {
        setDatefilter(selectedDate)
        setSwipingfilter(filterswiping)
        return () => {
            setDatefilter([null, null])
            setSwipingfilter('Show All')
        }
    }, [selectedDate, filterswiping])

    return (
        <ClickAwayListener disableReactTree onClickAway={handleClose}>
            <div>
                <Tooltip title="Filter list">
                    <IconButton
                        aria-label="filter list"
                        aria-haspopup="true"
                        onClick={handleClick}
                        variant="outlined"
                        color="primary"
                        style={{
                            border: '1px solid',
                            borderRadius: '5px',
                            width: '40px',
                            height: '40px',
                        }}
                        classes={{
                            label: classes.filterlabel,
                        }}
                    >
                        <FilterListIcon />
                    </IconButton>
                </Tooltip>

                {open ? (
                    <Paper className={classes.paper}>
                        <Box fontWeight="fontWeightMedium">
                            <Typography
                                variant="h6"
                                style={{textAlign: 'center', color: '#000000'}}
                            >
                                Filters
                            </Typography>
                            <>
                                <LocalizationProvider
                                    dateAdapter={DateFnsAdapter}
                                    locale={enLocale}
                                >
                                    {isMobile ? (
                                        <MobileDateRangePicker
                                            startText="Event Start"
                                            value={filteredDate}
                                            onChange={date =>
                                                handleDatefilterChange(date)
                                            }
                                            allowSameDateSelection={true}
                                            renderInput={(
                                                startProps,
                                                endProps
                                            ) => (
                                                <>
                                                    <TextField
                                                        {...startProps}
                                                        variant="outlined"
                                                        margin="dense"
                                                        size="small"
                                                    />
                                                    <DateRangeDelimiter>
                                                        {' '}
                                                        to{' '}
                                                    </DateRangeDelimiter>
                                                    <TextField
                                                        {...endProps}
                                                        variant="outlined"
                                                        margin="dense"
                                                        size="small"
                                                    />
                                                </>
                                            )}
                                        />
                                    ) : (
                                        <DesktopDateRangePicker
                                            startText="Event Start"
                                            value={filteredDate}
                                            onChange={date =>
                                                setDatefilter(date)
                                            }
                                            PopperProps={{disablePortal: true}}
                                            allowSameDateSelection={true}
                                            renderInput={(
                                                startProps,
                                                endProps
                                            ) => (
                                                <>
                                                    <TextField
                                                        {...startProps}
                                                        margin="dense"
                                                        size="small"
                                                        variant="outlined"
                                                    />
                                                    <DateRangeDelimiter>
                                                        {' '}
                                                        to{' '}
                                                    </DateRangeDelimiter>
                                                    <TextField
                                                        {...endProps}
                                                        margin="dense"
                                                        size="small"
                                                        variant="outlined"
                                                    />
                                                </>
                                            )}
                                        />
                                    )}
                                </LocalizationProvider>
                            </>

                            <TextField
                                id="swiping"
                                name="swiping"
                                label="Swiping"
                                select
                                fullWidth
                                autoComplete="off"
                                margin="normal"
                                size="small"
                                variant="outlined"
                                value={filteredswiping}
                                onChange={handleStatusChange}
                                SelectProps={{
                                    MenuProps: {disablePortal: true},
                                }}
                            >
                                {['Active', 'Inactive', 'Show All'].map(
                                    option => (
                                        <MenuItem key={option} value={option}>
                                            {option}
                                        </MenuItem>
                                    )
                                )}
                            </TextField>

                            <Box className={classes.filterbuttonBox}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    aria-label="add swiper"
                                    onClick={handleApply}
                                    size="small"
                                    className={classes.containedButton}
                                >
                                    APPLY
                                </Button>

                                <Button
                                    variant="outlined"
                                    color="primary"
                                    aria-label="lookup swiper by name"
                                    onClick={handleClearAll}
                                    size="small"
                                    className={classes.outlineButton}
                                >
                                    CLEAR ALL
                                </Button>
                            </Box>
                        </Box>
                    </Paper>
                ) : null}
            </div>
        </ClickAwayListener>
    )
}
